  (function () {
    if (customElements.get('collection-tabs')) return;

    customElements.define(
      'collection-tabs',
      class CollectionTabs extends HTMLElement {
        connectedCallback() {
          this._onClick = this._onClick.bind(this);
          this._onKeydown = this._onKeydown.bind(this);
          this.addEventListener('click', this._onClick);
          var tablist = this.querySelector('[role="tablist"]');
          if (tablist) tablist.addEventListener('keydown', this._onKeydown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          var tablist = this.querySelector('[role="tablist"]');
          if (tablist) tablist.removeEventListener('keydown', this._onKeydown);
        }

        _onClick(event) {
          var btn = event.target.closest('[data-tab-target]');
          if (!btn || !this.contains(btn)) return;
          this.activate(btn);
        }

        /* Roving-tabindex tab pattern (WAI-ARIA APG): Left/Right/Home/End move
           focus between pills and activate the newly-focused one. */
        _onKeydown(event) {
          var tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
          var idx = tabs.indexOf(document.activeElement);
          if (idx === -1) return;
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          else if (event.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          else if (event.key === 'Home') next = tabs[0];
          else if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            next.focus();
            this.activate(next);
          }
        }

        activate(btn) {
          var targetId = btn.getAttribute('data-tab-target');
          var panel = this.querySelector('#' + CSS.escape(targetId));
          if (!panel) return;

          var tabs = this.querySelectorAll('[data-tab-target]');
          for (var i = 0; i < tabs.length; i++) {
            var isActive = tabs[i] === btn;
            tabs[i].classList.toggle('c-collection-tabs__pill--active', isActive);
            tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
            tabs[i].setAttribute('tabindex', isActive ? '0' : '-1');
          }

          var panels = this.querySelectorAll('[role="tabpanel"]');
          for (var j = 0; j < panels.length; j++) {
            if (panels[j] === panel) {
              panel.removeAttribute('hidden');
            } else {
              panels[j].setAttribute('hidden', '');
            }
          }

          /* The revealed carousel's track was display:none while its panel was
             hidden, so it measured 0-width — force a re-measure now that it has
             real layout, and reset it to the first slide/page. */
          var carousel = panel.querySelector('c-carousel');
          if (carousel && typeof carousel.refresh === 'function') {
            if (carousel.track) carousel.track.scrollTo({ left: 0 });
            carousel.refresh();
          }
        }
      }
    );
  })();
